export default {
    PLBSGCB: { name: 'PLBSGCB' },
    'PLBS+': { name: 'PLBS+' },
    DCCPLBS: { name: 'DCCPLBS' },
    PLBS: { name: 'PLBS' }
};